import loadable from '@loadable/component'

export const ESGKeEntityHighlighty = loadable(() => import('./EntityHighlight'))
export const EntityLogo = loadable(() => import('./EntityLogo'))
export const Entities = loadable(() => import('./Entities'))
export type { EntitiesProps } from './Entities'
export type { EntityHighlightProps } from './EntityHighlight'
export type { EntityLogoProps } from './EntityLogo'
export type { EntityLogoRenderImageProps } from './EntityLogo'
